var exports = {
  "Pc": "TagListField.module__tagsContainer___U3dPN3",
  "Pr": "TagListField.module__tagsHeader___U3dPN3",
  "cm": "TagListField.module__tagsLabel___U3dPN3",
  "jw": "TagListField.module__tagInputRow___U3dPN3",
  "Cs": "TagListField.module__tagsList___U3dPN3",
  "Tc": "TagListField.module__tag___U3dPN3",
  "xH": "TagListField.module__tagRemoveButton___U3dPN3",
};

module.exports = exports;
